import cs from 'classnames';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import { useStyles } from '@tcs/client-portal-common/components/molecules/Table/style';
import { Unicode } from '@tcs/common/utils/unicode';
interface CellProps {
  value: number;
}

const UnitDebitCreditCell = ({ value }: CellProps) => {
  const classes = useStyles({});

  const formatContent = () => {
    if (value == null) return Unicode.EmDash;
    return `${value > 0 ? '+' : ''}${value.toLocaleString('en-US')} units`;
  };

  return (
    <BaseCell
      value={formatContent()}
      isPrivate
      align="left"
      className={cs(classes.alignNumbers, {
        [classes.debit]: value && value < 0,
      })}
    />
  );
};

export default UnitDebitCreditCell;
